export enum MarkerMode {
  dots = 0,
  circles = 1,
  plants = 2,
  buildings = 3,
}

export enum SensorStatus {
  INACTIVE = 'inactive',
  CRITICAL = 'critical',
  WARNING = 'warning',
  WORKING = 'working',
}
